const state = {
  ar4105Monitoring: undefined,
  heatpumpEnabled: undefined,
  cosPhiQu: undefined,
  cosPhi0: undefined,
  cosPhi1: undefined,
  minATQ_U_SP1: undefined,
  maxATQ_U_SP1: undefined,
  minATQ_U_SP2: undefined,
  maxATQ_U_SP2: undefined,
  minATQ_U_SP3: undefined,
  maxATQ_U_SP3: undefined,
  minATQ_U_SP4: undefined,
  maxATQ_U_SP4: undefined,
  operationMode2: undefined,
  operationMode3: undefined,
  limitSetupEnabled: undefined,
  inverterType2: undefined,
  knxConnection: undefined,
  torEnabled: undefined,
  austriaSelected: undefined,
  heatingElementEnabled: undefined
};

const mutations = {
  SET_RULE_PROVIDER: (state, provider) => {
    state[provider.name] = provider.value;
  }
};

const actions = {
  setRuleProvider(context, rule) {
    context.commit('SET_RULE_PROVIDER', rule);
  }
};

const getters = {
  getRule: state => ruleName => state[ruleName]
};

export default {
  state,
  mutations,
  actions,
  getters
};
